// Mock data for Top Choice Lending — pulled from www.topchoicelending.net

export const company = {
  name: "Top Choice Lending",
  tagline: "You made us your Top Choice.",
  taglineB: "We made you our Top Priority.",
  phone: "(800) 934-8103",
  phoneRaw: "8009348103",
  email: "contact@topchoicelending.net",
  address: {
    line1: "310 Main St. Suite 300",
    city: "Houston",
    state: "TX",
    zip: "77002"
  },
  hours: [
    { day: "Monday – Friday", time: "9:00 AM – 6:00 PM" },
    { day: "Saturday", time: "Closed" },
    { day: "Sunday", time: "Closed" }
  ],
  serviceStates: ["Texas", "Louisiana", "Florida"],
  applyUrl: "https://topchoicelending.my1003app.com/",
  socials: {
    facebook: "https://www.facebook.com/",
    linkedin: "https://www.linkedin.com/",
    instagram: "https://www.instagram.com/"
  }
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Loans", href: "#services" },
  { label: "Calculator", href: "#calculator" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" }
];

export const services = [
  {
    id: "pre-approval",
    title: "Mortgage Pre-Approval",
    kicker: "Get The Best Deal",
    description:
      "Whether you\u2019re buying your first home or looking for a new investment property, we handle all your pre-approval needs so you can enjoy the excitement of purchasing real estate.",
    icon: "badge-check"
  },
  {
    id: "comparison",
    title: "Loan Comparison",
    kicker: "Own Your Dream Home",
    description:
      "Save money by receiving the best financing terms available. We shop the best down-payment and interest options across a wide network of lenders.",
    icon: "scale"
  },
  {
    id: "refinancing",
    title: "Refinancing",
    kicker: "More Ways to Save",
    description:
      "From lowering your rate to cash-out refi, we take the complications out of refinancing so you can put more money back in your pocket.",
    icon: "refresh-cw"
  }
];

export const loanTypes = [
  { title: "Conventional", desc: "Flexible terms for buyers with strong credit.", icon: "home" },
  { title: "FHA", desc: "Low down payments, ideal for first-time buyers.", icon: "key-round" },
  { title: "VA", desc: "Exclusive benefits for veterans and active service.", icon: "shield" },
  { title: "USDA", desc: "$0 down for eligible rural & suburban homes.", icon: "trees" },
  { title: "Jumbo", desc: "Financing for luxury and high-value properties.", icon: "gem" },
  { title: "Refinance", desc: "Rate-and-term or cash-out refinancing.", icon: "refresh-cw" },
  { title: "Commercial", desc: "Multifamily, retail, office & mixed-use.", icon: "building-2" },
  { title: "Hard Money / Bridge", desc: "Fast capital for time-sensitive deals.", icon: "zap" },
  { title: "Business Lines of Credit", desc: "Working capital for growing operations.", icon: "trending-up" }
];

export const stats = [
  { value: "$1.2B+", label: "Loans Closed" },
  { value: "15,000+", label: "Happy Families" },
  { value: "3", label: "States Licensed" },
  { value: "4.9\u2605", label: "Client Rating" }
];

export const process = [
  { step: "01", title: "Apply Online", desc: "Complete our secure application in under 10 minutes." },
  { step: "02", title: "Get Pre-Approved", desc: "We shop dozens of lenders to find your best rate." },
  { step: "03", title: "Find Your Home", desc: "Shop with confidence knowing exactly what you can afford." },
  { step: "04", title: "Close With Confidence", desc: "We guide you all the way to closing day \u2014 and beyond." }
];

// Self-hosted (ticket 98 N15): the marketing site used to hotlink these from
// images.unsplash.com. Only the two keys that are rendered are kept.
export const images = {
  hero: "/assets/marketing/hero.jpg",
  handshake: "/assets/marketing/handshake.jpg"
};
